import React, { useState } from "react";
import FluentUiIcon from "../../../../../../assets/fluent-ui-icon";
import { FluentButton } from "../../../../../../components/FluentUI/Fluent-Button";
import PropTypes from "prop-types";
import { FluentDialog2 } from "../../../../../../components/FluentUI/Fluent-Dialog2";
import { FluentInput } from "../../../../../../components/FluentUI/Fluent-Input";

export const RenameDialog = ({ text, open, OnCancel, OnSave, OnBlurLabel }) => {
  const [message, setMessage] = useState({
    label: text,
    validationMessage: "",
  });

  const Save = () => {
    if (message.validationMessage !== "") return;
    OnSave(message.label);
  };

  const OnBlur = (e) => {
    const { message, formName } = OnBlurLabel(e.target.value);

    setMessage((prev) => ({
      ...prev,
      validationMessage: message,
      label: formName,
    }));
  };

  return (
    <FluentDialog2 open={open}>
      <div className="task-type-dialog-title">
        <p>Rename this Form?</p>
        <p onClick={OnCancel}>
          <FluentUiIcon name={"DismissRegular"} color={"#212121"} size={20} />
        </p>
      </div>
      <div className="task-type-dialog-content">
        <FluentInput
          label={"Please enter a new Form title"}
          required={true}
          onBlur={OnBlur}
          validationMessage={message.validationMessage}
          defaultValue={message.label}
        ></FluentInput>
      </div>
      <div className="task-type-dialog-footer">
        <FluentButton
          onClick={OnCancel}
          text={"Cancel"}
          backgroundColor={"#0F6CBD"}
        />
        <FluentButton
          onClick={Save}
          appearance="primary"
          text="Save"
          backgroundColor={"#0F6CBD"}
        />
      </div>
    </FluentDialog2>
  );
};

RenameDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  OnCancel: PropTypes.func.isRequired,
  OnBlurLabel: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  OnSave: PropTypes.func.isRequired,
};
